var exports = {
  "M6": "x234b8571--e55953--slide",
  "dV": "x234b8571--e55953--slide__image-wrapper",
  "VL": "x234b8571--e55953--information-container",
  "DD": "x234b8571--e55953--title",
  "VA": "x234b8571--e55953--subtitle",
  "x6": "x234b8571--e55953--button",
  "ed": "x234b8571--e55953--disclaimer",
  "RL": "x234b8571--e55953--disclaimer--inactive-text",
  "Pf": "x234b8571--e55953--label",
};

module.exports = exports;
